module.exports = __webpack_public_path__ + "img/map-dashboard.ea11ac7f.svg";